/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { ChatbotService, ChatMessageRequest, ChatMessageResponse } from 'src/services/chatbot.service';

export const useSendChatMessage = (): UseMutationResult<ChatMessageResponse, Error, ChatMessageRequest, void> =>
  useMutation({
    mutationFn: (data: ChatMessageRequest) => ChatbotService.sendMessageApi(data),
    onSuccess: () => {
      AlertAdapter('Message sent successfully.', 'success');
    },
    onError: (error: Error) => {
      AlertAdapter(error.message || 'Failed to send message.', 'error');
    },
  });
